var map = {
	"./1/results.json": 2555,
	"./2/results.json": 2556,
	"./3/results.json": 2557,
	"./4/results.json": 2558,
	"./5/results.json": 2559,
	"./6/results.json": 2560,
	"./7/results.json": 2561,
	"./8/results.json": 2562
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2554;


//////////////////
// WEBPACK FOOTER
// ./src/services/API/fixtures/institutions/assessmentsperceptions ^\.\/.*\/results\.json$
// module id = 2554
// module chunks = 0